import React, { useState, useEffect } from "react";
import { BASE_URL } from ".././constant";
import axios from "axios";
import styles from "./style.module.css";

import { FaSearch } from "react-icons/fa";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";

// Styled components for the menu items
const MenuContainer = styled.div`
  display: flex;
  overflow-x: auto; /* Enable horizontal scrolling */
  padding: 10px;
  white-space: nowrap;

  ::-webkit-scrollbar {
    display: none; /* Hide scrollbar for cleaner look */
  }
`;

const MenuItem = styled.div`
  text-align: center;
  margin: 0 8px;
  cursor: pointer;
`;

const MenuImageContainer = styled.div`
  width: 80px; /* Match with MenuImage dimensions */
  height: 60px; /* Match with MenuImage dimensions */
  border-radius: 10px; /* Rounded corners */
  overflow: hidden; /* Hide overflow for consistent rounding */
`;

const MenuImage = styled.img`
  width: 100%; /* Ensure image fills container */
  height: 100%; /* Ensure image fills container */
  object-fit: contain; /* Cover ensures aspect ratio */
`;

const MenuText = styled.p`
  font-size: 12px;
  margin-top: 5px;
  color: white;
  max-width: 82px;
  word-wrap: break-word;
  white-space: normal;
  text-align: center;
`;

function SearchBar({ searchTerm, setSearchTerm }) {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/category/all-unhide`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching Categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleSearchProduct = async () => {
    navigate(`/shop?search=${searchTerm}`);
  };
  const handleCardClick = (category) => {
    setSelectedCategory(category);
  };
  return (
    <div>
      {(location.pathname === "/" || location.pathname === "/shop") && (
        <div className={styles.search_bar}>
          {/* Search Icon and Input */}
          <div className={styles.search_container}>
            <input
              type="text"
              placeholder="Search"
              className={styles.search_input}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setSearchTerm(e.target.value);
                  handleSearchProduct();
                }
              }}
            />
            <button
              style={{ border: "none" }}
              onClick={(e) => {
                e.preventDefault();
                setSearchTerm(e.target.value);
                handleSearchProduct();
              }}
            >
              <FaSearch size={20} />
            </button>
          </div>
        </div>
      )}

      {/* Menu Container for Categories */}
      {(location.pathname === "/" || location.pathname === "/shop") && (
        <MenuContainer className={styles.main_container}>
          {categories.map((category, index) => (
            <MenuItem
              key={index}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              onClick={() => handleCardClick(category)}
            >
              <MenuImageContainer>
                <MenuImage
                  src={category.categoryImage}
                  alt={category.categoryName}
                  style={{ border: "2px solid black", borderRadius: "10px" }}
                  className="w-full h-full object-cover "
                />
              </MenuImageContainer>
              <MenuText style={{ color: "#000" }}>
                {" "}
                {category.categoryName}
              </MenuText>
            </MenuItem>
          ))}
        </MenuContainer>
      )}

      <div
        className="modal fade "
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content  subcategory-modal-container">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                {selectedCategory?.categoryName || "Category Name"}
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body subcategory-modal">
              {selectedCategory?.subcategoryList?.length > 0
                ? selectedCategory.subcategoryList.map((subcategory) => (
                    <div
                      key={subcategory.subCategoryId}
                      className="subcategory-card"
                      onClick={() => {
                        navigate(
                          `/shop?subcategory=${subcategory.subCategoryName}`
                        );
                        window.location.reload();
                      }}
                    >
                      {subcategory.subCategoryNameImage ? (
                        <img
                          src={subcategory.subCategoryNameImage}
                          alt={subcategory.subCategoryName}
                          className="img-fluid"
                        />
                      ) : (
                        <div className="placeholder-image">
                          <img src="https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg" />
                        </div>
                      )}
                      <p className="subcategory-name">
                        {subcategory.subCategoryName}
                      </p>
                    </div>
                  ))
                : "No subcategories available."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
